export enum WindowKeyListener {
  ClaimantMatching = 'C',
  AuditCompanyMatching = 'R',
  ToggleNotesEmails = 'N',
}
